import Login from '../containers/Login'

import ListingUser from '../containers/users/ListingUser'
import FormUser from '../containers/users/FormUser'
import Convites from '../containers/Convites'
import CadastroConvite from '../containers/Cadastro'
import RedefinirSenha from '../containers/RedefinirSenha'
import MeuCadastro from '../containers/MeuCadastro'

import ListingCustomer from '../containers/customers/ListingCustomer'
import FormCustomer from '../containers/customers/FormCustomer'

import ListingMailing from '../containers/mailing/ListingMailing'
import FormMailing from '../containers/mailing/FormMailing'

import FormLead from '../containers/leads/FormLead'
import ImportacaoLead from '../containers/leads/Importacao/'


import GestaoAssessor from '../containers/GestaoAssessor'
import AgendamentoLead from "../containers/agendamentoLeads/index.jsx";
import FormAgendamentoLead from '../containers/agendamentoLeads/Form.jsx'
import Termo from '../containers/Termo'

import Relatorio from '../containers/Relatorio'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';


import LeadsList from "../containers/leads/IndexLead/index";


import Home from "../containers/Home";
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import FolderOpenOutlinedIcon from '@material-ui/icons/FolderOpenOutlined';
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';
import InsertInvitationOutlinedIcon from '@material-ui/icons/InsertInvitationOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';

const paths =  [
    {
        "to":"/",
        "container":Login,
        "text":"Login",
        "viewMenu":false,
        "publico":true
    },
    {
        "to":"/login",
        "container":Login,
        "text":"Login",
        "viewMenu":false,
        "publico":true
    },
    {
        "to":"/cadastro/:codigo",
        "container":CadastroConvite,
        "text":"Cadastro",
        "viewMenu":false,
        "publico":true
    },
    {
        "to":"/redefinir-senha/:codigo",
        "container":RedefinirSenha,
        "text":"Redefinir senha",
        "viewMenu":false,
        "publico":true
    },
    {
        "to":"/home",
        "icon":<HomeOutlinedIcon/>,
        "container":Home,
        "text":"Início",
        "viewMenu":true
    },
    {
        "to":"/users",
        "icon":<AccountBoxOutlinedIcon/>,
        "container":ListingUser,
        "acao":"gerenciar_usuarios",
        "text":"Usuários",
        "viewMenu":true
    },
    {
        "to":"/users/convites",
        "container":Convites,
        "acao":"gerenciar_usuarios",
        "text":"Convites",
        "viewMenu":false
    },
    {
        "to":"/user/new",
        "container":FormUser,
        "acao":"gerenciar_usuarios",
        "text":"Novo Usuário",
        "viewMenu":false
    },
    {
        "to":"/user/:id/edit",
        "container":FormUser,
        "acao":"gerenciar_usuarios",
        "text":"Editar Usuário",
        "viewMenu":false
    },
    {
        "to":"/customer/new",
        "container":FormCustomer,
        "acao":"editar_clientes",
        "text":"Novo Cliente",
        "viewMenu":false
    },
    {
        "to":"/customer/:id/edit",
        "container":FormCustomer,
        "acao":"visualizar",
        "text":"Editar Cliente",
        "viewMenu":false
    },
    {
        "to":"/customers",
        "icon":<PeopleOutlinedIcon/>,
        "container":ListingCustomer,
        "acao":"visualizar",
        "text":"Clientes",
        "viewMenu":true
    },
    {
        "to":"/mailing",
        "icon":<FolderOpenOutlinedIcon/>,
        "container":ListingMailing,
        "acao":"visualizar",
        "text":"Mailing",
        "viewMenu":true
    },
    {
        "to": "/leads",
        "container": LeadsList,
        "icon":<ListAltOutlinedIcon/>,
        "acao":"visualizar",
        "text": "Leads",
        "viewMenu": true
    },
    {
        "to": "/leads/novo",
        "container":  FormLead,
        "acao":"editar_leads",
        "viewMenu": false
    },
    {
        "to": "/leads/importacao",
        "container":  ImportacaoLead,
        "icon":<ListAltOutlinedIcon/>,
        "acao":"importar",
        "text": "Importação Lead",
        "viewMenu": false
    },
    {
        "to": "/leads/:id/edit",
        "container": FormLead,
        "acao":"visualizar",
        "viewMenu": false
    },
    {
        "to":"/mailing/new",
        "container":FormMailing,
        "acao":"editar_clientes",
        "text":"Novo Mailing",
        "viewMenu":false
    },
    {
        "to":"/mailing/:id/edit",
        "container":FormMailing,
        "acao":"visualizar",
        "text":"Editar Mailing",
        "viewMenu":false
    },
    {
        "to":"/mailing/:id_mailing/lead/new",
        "container":FormLead,
        "text":"Novo Lead",
        "acao":"editar_leads",
        "viewMenu":false
    },
    {
        "to":"/mailing/:id_mailing/lead/:id/edit",
        "container":FormLead,
        "acao":"visualizar",
        "text":"Lead",
        "viewMenu":false
    },
    {
        "to":"/gestao-assessor",
        "icon":<AssignmentOutlinedIcon/>,
        "container": GestaoAssessor,
        "text": "Gestão do Assessor",
        "acao":"visualizar",
        "viewMenu": true
    },
    {
        "to": "/agendamento-lead",
        "container": AgendamentoLead,
        "icon":<InsertInvitationOutlinedIcon/>,
        "acao":"visualizar",
        "text": "Reuniões agendadas",
        "viewMenu": true
    }, {
        "to": "/agendamento-lead/novo/:id_lead?",
        "container": FormAgendamentoLead,
        "viewMenu": false,
        "acao":"editar_reunioes",
        "text": "Agendamento de Leads",
    },
    {
        "to": "/agendamento-lead/:id",
        "container": FormAgendamentoLead,
        "viewMenu": false,
        "acao":"visualizar",
        "text": "Visualizar Agendamento de Leads",
    },
    {
        "to": "/politica",
        "container": Termo,
        "viewMenu": false,
        "publico":true
    },
    {
        "to": "/relatorio",
        "container": Relatorio,
        "icon":<ListAltOutlinedIcon/>,
        "viewMenu": true,
        "acao":"gerar_relatorios",
        "text": "Relatório",
    },
    {
        "to": "/meu-cadastro",
        "container": MeuCadastro,
        "icon":<PersonOutlineOutlinedIcon/>,
        "viewMenu": true,
        "acao":"meu_cadastro",
        "text": "Meu cadastro",
    }
]

export default paths;
